module.exports = "https://coursera_assets.s3.amazonaws.com/images/49f6fc3123e17dd16361d5b70bc258a9.png";